import config from "config/config";
import { isAgentPortal } from "js/utilities";

const getAlerts = async () => {
  let options = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ClientSecret: config.PORTAL_CLIENT_SECRET,
    },
  };
  let queryString = "";
  if (isAgentPortal()) {
    queryString = "portal=agent";
  } else {
    queryString = "portal=customer";
  }

  const response = await fetch(
    `${config.REG_API_BASE_URL}/alerts?${queryString}`,
    options
  );

  if (!response.ok) {
    throw response;
  } else {
    const data = await response.json();
    return data;
  }
};

export default getAlerts;
